"use client";

import { useEffect, useState } from "react";
import { Envelope } from "@/lib/icons";
import { useAuth } from "@/lib/auth-context";
import { apiGetQuiet } from "@/lib/api";

export default function SmtpButton() {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!user) return;
    apiGetQuiet<{ allowed: boolean }>("/terminal/access")
      .then((res) => setAllowed(res.allowed))
      .catch(() => setAllowed(false));
  }, [user]);

  if (!user || !allowed) return null;

  return (
    <a
      href="/configure-smtp"
      className="text-muted hover:text-accent transition-colors"
      title="Configure SMTP"
    >
      <Envelope />
    </a>
  );
}
